/**
 * An OrderSet is a collection of ProviderOrders' and NursingOrders that can be
 * applied to a patient.  The orders are stored just by their ids.
 */
export class OrderSet {

  id: string;
  name: string;
  providerOrderIds: string[] = [];
  nursingOrderIds: string[] = [];

  constructor(data: {
    id?: string,
    name: string,
    providerOrderIds: string[],
    nursingOrderIds: string[],
  }) {
    this.id = data.id || '' + Date.now(); // Set orderSet ID to be the date in milliseconds
    this.name = data.name;
    this.providerOrderIds = data.providerOrderIds;
    this.nursingOrderIds = data.nursingOrderIds;
  }
}
